import {PayloadAction} from '@reduxjs/toolkit';
//types
import {
	IOrganizationAttendeesReducer,
	IOrganizationAttendeesListResponse,
	IOrganizationAttendeesStatistics,
	IOrganizationAttendee,
} from '../../utils/types';

export const pendingOperation = (state: IOrganizationAttendeesReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: IOrganizationAttendeesReducer) => {
	state.isLoading = false;
};

export const getAttendeeOperation = (
	state: IOrganizationAttendeesReducer,
	{payload}: PayloadAction<IOrganizationAttendee>
) => {
	state.attendee = payload;
	state.isLoading = false;
};

export const getAttendeesListOperation = (
	state: IOrganizationAttendeesReducer,
	{payload}: PayloadAction<IOrganizationAttendeesListResponse>
) => {
	state.attendeesList = payload;
	state.isLoading = false;
};

export const getAttendeesStatisticsOperation = (
	state: IOrganizationAttendeesReducer,
	{payload}: PayloadAction<IOrganizationAttendeesStatistics>
) => {
	state.attendeesStatistics = payload;
	state.isLoading = false;
};

export const clearAttendeeOperation = (state: IOrganizationAttendeesReducer) => {
	state.attendee = null;
};

export const clearAttendeesDataOperation = (
	state: IOrganizationAttendeesReducer,
	initialState: IOrganizationAttendeesReducer
) => {
	Object.assign(state, initialState);
};
